import styled from 'styled-components';
import svgItem from '../../assets/hotels/free-cancellation-active.svg';

const FreeCancellation = styled(svgItem as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '4rem'};
  height: ${props => props.height || '4rem'};
  fill: ${props => props.fill || props.theme.colors.black.base};
`;

export default FreeCancellation;
